(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6479],{

/***/ 7133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P8": function() { return /* binding */ CouponDiscount; },
  "KM": function() { return /* binding */ Order; },
  "ZA": function() { return /* binding */ OrderFromHistory; }
});

// UNUSED EXPORTS: default

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/BehaviorSubject.js + 3 modules
var BehaviorSubject = __webpack_require__(20090);
// EXTERNAL MODULE: ./src/utils/json-storage.js
var json_storage = __webpack_require__(19022);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/rxjs/_esm5/internal/operators/distinctUntilChanged.js
var distinctUntilChanged = __webpack_require__(41931);
;// CONCATENATED MODULE: ./src/utils/store.js


function emitOnAttrChange(subject, key) {
  return subject.pipe((0,distinctUntilChanged/* distinctUntilChanged */.x)(function (prev, curr) {
    return get_default()(prev, key) === get_default()(curr, key);
  }));
}
;// CONCATENATED MODULE: ./src/store/order.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var couponSubject = new BehaviorSubject/* BehaviorSubject */.X(0);
var INITIAL_SUBJECT_VALUE = undefined;
var STORAGE_NAME_ORDER = 'order';
var STORAGE_NAME_ORDER_HISTORY = 'prevOrder';
var meta = {
  cached: false,
  fetched: false,
  updatedAt: new Date()
};
var metaOrderFromHistory = {
  cached: false,
  fetched: false,
  updatedAt: new Date()
};
var Order = {
  subject: new BehaviorSubject/* BehaviorSubject */.X(null),
  lazyInit: function lazyInit() {
    if (Order.subject.value !== null) return Order.subject;
    var storage = window.localStorage;
    var order = json_storage/* default.get */.ZP.get(STORAGE_NAME_ORDER, {
      storage: storage
    });
    Object.assign(meta, {
      cached: true,
      fetched: false,
      updatedAt: new Date()
    });
    Order.subject = new BehaviorSubject/* BehaviorSubject */.X(order);
    return Order.subject;
  },
  update: function update(order) {
    var order$ = Order.lazyInit();
    var storage = window.localStorage;
    json_storage/* default.set */.ZP.set(STORAGE_NAME_ORDER, order, {
      storage: storage
    });
    order$.next(order);
    Object.assign(meta, {
      fetched: true,
      updatedAt: new Date()
    });
  },
  subscribe: function subscribe(setState) {
    var order = Order.lazyInit();
    return order.subscribe(setState);
  },
  getValue: function getValue() {
    var order = Order.lazyInit();
    return order.value;
  },
  getService$: function getService$() {
    var order = Order.lazyInit();
    return emitOnAttrChange(order, 'selectedService');
  },
  setSelectedAddress: function setSelectedAddress(addressObject) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      addressObject: addressObject
    }));
  },
  setTimeslot: function setTimeslot(slot) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      timeSlotEnd: slot.timeSlotEnd,
      timeSlotStart: slot.timeSlotStart,
      timeslotId: slot._id ? slot._id : null
    }));
  },
  getTimeSlotStart: function getTimeSlotStart() {
    var order = Order.getValue();
    return order.timeSlotStart;
  },
  setChangesAllowed: function setChangesAllowed(option) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      changesAllowed: option
    }));
  },
  setPointsUse: function setPointsUse(usePoints) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      redeemPoints: usePoints
    }));
  },
  setPlasticBags: function setPlasticBags(wantPlasticBags) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      wantPlasticBags: wantPlasticBags
    }));
  },
  setInvoiceInfo: function setInvoiceInfo(invoiceInfo) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      invoice: {
        companyAddress: invoiceInfo.companyAddress,
        companyName: invoiceInfo.companyName,
        companyPhone: invoiceInfo.companyPhone,
        profession: invoiceInfo.profession,
        taxId: invoiceInfo.AFM,
        taxOffice: invoiceInfo.DOY
      }
    }));
  },
  setCouponCode: function setCouponCode(code) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      couponCode: code
    }));
  },
  setPaymentType: function setPaymentType(paymentType, datacashReference) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      paymentType: paymentType,
      datacashReference: datacashReference
    }));
  },
  setProducts: function setProducts(products) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      products: products
    }));
  },
  setComments: function setComments(comments) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      comments: comments
    }));
  },
  setOffers: function setOffers(offers) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      offers: offers
    }));
  },
  setShopId: function setShopId(shop) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      shop: shop
    }));
  },
  setPenalty: function setPenalty(penaltyFee, minimumPrice) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      penaltyFee: penaltyFee,
      minimumPrice: minimumPrice
    }));
  },
  setDiscountCampaignsApplied: function setDiscountCampaignsApplied(discountCampaignsApplied) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      discountCampaignsApplied: discountCampaignsApplied
    }));
  },
  setTotalPrice: function setTotalPrice(totalPrice) {
    var order = Order.getValue();
    Order.update(_objectSpread(_objectSpread({}, order), {}, {
      totalPrice: totalPrice
    }));
  },
  reset: function reset() {
    Order.update(undefined);
  },
  deleteProperty: function deleteProperty(properties) {
    var order = Order.getValue();
    var newOrder = properties.reduce(function (acc, property) {
      return _objectSpread(_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, property, null));
    }, order);
    Order.update(newOrder);
  }
};
var CouponDiscount = {
  update: function update(code) {
    couponSubject.next(code);
  },
  subscribe: function subscribe(setState) {
    return couponSubject.subscribe(setState);
  },
  getValue: function getValue() {
    return couponSubject.value;
  }
};
var OrderFromHistory = {
  subject: INITIAL_SUBJECT_VALUE,
  lazyInit: function lazyInit() {
    if (OrderFromHistory.subject) return OrderFromHistory.subject;
    var storage = window.localStorage;
    var orderFromHistory = json_storage/* default.get */.ZP.get(STORAGE_NAME_ORDER_HISTORY, {
      storage: storage
    });
    Object.assign(metaOrderFromHistory, {
      cached: true,
      fetched: false,
      updatedAt: new Date()
    });
    OrderFromHistory.subject = new BehaviorSubject/* BehaviorSubject */.X(orderFromHistory);
    return OrderFromHistory.subject;
  },
  subscribe: function subscribe(setState) {
    var orderFromHistory = OrderFromHistory.lazyInit();
    return orderFromHistory.subscribe(setState);
  },
  update: function update(order) {
    var orderFromHistory$ = OrderFromHistory.lazyInit();
    orderFromHistory$.next(order);
    Object.assign(metaOrderFromHistory, {
      fetched: true,
      updatedAt: new Date()
    });
    var storage = window.localStorage;
    json_storage/* default.set */.ZP.set(STORAGE_NAME_ORDER_HISTORY, order, {
      storage: storage
    });
  },
  getValue: function getValue() {
    var orderFromHistory = OrderFromHistory.lazyInit();
    return orderFromHistory.value;
  }
};
/* harmony default export */ var order = ({
  Order: Order,
  CouponDiscount: CouponDiscount,
  OrderFromHistory: OrderFromHistory
});

/***/ }),

/***/ 21471:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tg": function() { return /* binding */ formatAddress; },
/* harmony export */   "oY": function() { return /* binding */ getAddressTypeInfo; }
/* harmony export */ });
function formatAddress() {
  var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var formatted = '';

  if (address.street) {
    formatted = address.street;
  }

  if (address.streetNo) {
    formatted = "".concat(formatted, " ").concat(address.streetNo, ",");
  }

  if (address.city) {
    formatted = "".concat(formatted, " ").concat(address.city);
  }

  if (address.postalCode) {
    formatted = "".concat(formatted, ", ").concat(address.postalCode);
  }

  return formatted;
}
function getAddressTypeInfo(type) {
  switch (type) {
    case 'work':
      return {
        label: 'Εργασία'
      };

    case 'other':
      return {
        label: 'Άλλο'
      };

    default:
      return {
        label: 'Σπίτι'
      };
  }
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  formatAddress: formatAddress,
  getAddressTypeInfo: getAddressTypeInfo
});

/***/ }),

/***/ 76480:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/history",
      function () {
        return __webpack_require__(53896);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,2013,3874,3996,4843,5790,9950,3026,9774,2888,179], function() { return __webpack_exec__(16395), __webpack_exec__(76480); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);